import { createSelector } from 'reselect';
import { getTeamIds } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { getCurrentInbox } from './getCurrentInbox';
export const getCurrentInboxTeamIds = createSelector([getCurrentInbox], getTeamIds);